import { render } from "./HomeDashboard.vue?vue&type=template&id=ea2b8bb0&scoped=true"
import script from "./HomeDashboard.vue?vue&type=script&lang=js"
export * from "./HomeDashboard.vue?vue&type=script&lang=js"

import "./HomeDashboard.vue?vue&type=style&index=0&id=ea2b8bb0&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea2b8bb0"]])

export default __exports__